<template>
  <div
    v-if="(article.family_id || article.parent_family_id == 1) ||
           (article.family && (article.family.id == 1 || article.family.parent_family_id == 1))"
    class="icons-wrapper"
  >
    <!-- <v-img
      v-if="article.property_13 == 1"
      :height="iconSize"
      :width="iconSize"
      class="icon"
      src="../../public/icons/tubeless.svg"
    /> -->
    <v-img
      v-if="article.property_14 == 1"
      :height="iconSize"
      :width="iconSize"
      class="icon"
      src="../../public/icons/run_flat.svg"
    />
    <v-img
      v-if="article.property_46 == 1"
      :height="iconSize"
      :width="iconSize"
      class="icon"
      src="../../public/icons/3pms.svg"
    />
    <v-img
      v-if="article.property_37 == 1"
      :height="iconSize"
      :width="iconSize"
      class="icon"
      src="../../public/icons/snowflake.svg"
    />
  </div>
</template>

<script>
export default {
  name: "ArticleIcons",
  props: {
    article: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      iconSize: 20, // better for inline alignment
    };
  },
};
</script>

<style scoped>
.icons-wrapper {
  display: inline-flex;
  align-items: center;
  gap: 6px; /* space between icons */
  margin-left: 8px; /* small spacing from text */
  vertical-align: middle; /* keeps it aligned with text baseline */
}

.icon {
  display: inline-block;
}
</style>